"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index55.js"),o=require("./index113.js");var s=e.global,a=o.classofRaw,r=a(s.process)==="process";exports.engineIsNode=r;
